export const ADD_CHART_METRIC = '@financials/add-metric';
export const REMOVE_CHART_METRIC = '@financials/remove-metric';
export const CLEAR_CHART_METRICS = '@financials/clear-metrics';
export const SET_PERIOD = '@financials/set-period';
export const SET_TAB = '@financials/set-tab';


